import React from 'react';
import { Modal } from 'antd';

type RefreshConfirmationProps = {
  onRefresh: () => void;
  onCancel: () => void;
};

export default function RefreshConfirmationModal({
  onRefresh,
  onCancel,
}: RefreshConfirmationProps): JSX.Element {
  return (
    <Modal
      open
      centered
      title={<strong>Continue Session</strong>}
      closable={false}
      okText={'Continue session'}
      onOk={onCancel}
      cancelText={'New session'}
      onCancel={onRefresh}
    >
      <>
        <p>Would you like to start a new session or continue your session?</p>
        <p>
          Starting a new session will clear all settings (points, map,
          validations, etc.).
        </p>
      </>
    </Modal>
  );
}
